import { sortBySequenceNumber } from 'shared/lib/common-util'
import { fromAdditionalReferenceResponse, toUpdateAdditionalReferenceRequest } from '../models/mapper'
import { AdditionalReferenceUpdate } from '../models/request'
import { AdditionalReference, AdditionalReferenceParentType } from '../models/types'
import { updateDraftAdditionalReferencesV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateDraftAdditionalReferences(
  parentId: number,
  parentType: AdditionalReferenceParentType,
  data: AdditionalReferenceUpdate[],
): Promise<AdditionalReference[]> {
  const requests = data.map((d) => toUpdateAdditionalReferenceRequest(parentId, parentType, d))
  const responses = await updateDraftAdditionalReferencesV2(requests)

  return responses.map((
    response,
    index,
  ) => fromAdditionalReferenceResponse(response, parentType, parentId, index))
    .sort(sortBySequenceNumber)
}
